export default function Python_Casting() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Python_Casting</h1>
      <p>Content for Python_Casting goes here.</p>
    </div>
  );
}